import { hhmm } from '@noorview/core';

/* Small DOM helpers shared by every widget design. */

export function el<K extends keyof HTMLElementTagNameMap>(tag: K, cls?: string, text?: string): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text != null) e.textContent = text;
  return e;
}
/** Sets text only when it changed, so a once-a-second tick costs almost nothing. Returns true if the length changed. */
export function setText(node: Element, value: string): boolean {
  const prev = node.textContent ?? '';
  if (prev === value) return false;
  node.textContent = value;
  return prev.length !== value.length;
}

export const t12 = (date: Date, tz: string, h12: boolean) => hhmm(date, tz, { h12 });
export const wall12 = (t: string | undefined, h12: boolean) => {
  if (!t) return '—';
  if (!h12) return t;
  const [h, m] = t.split(':').map(Number);
  return `${(h! % 12) || 12}:${String(m).padStart(2, '0')}`;
};


const NS = 'http://www.w3.org/2000/svg';
/** An SVG element with attributes. */
export function sv<K extends keyof SVGElementTagNameMap>(tag: K, attrs: Record<string, string | number> = {}, ...kids: SVGElement[]): SVGElementTagNameMap[K] {
  const e = document.createElementNS(NS, tag);
  for (const [k, v] of Object.entries(attrs)) e.setAttribute(k, String(v));
  e.append(...kids);
  return e;
}
/** Minutes past midnight for "HH:MM". */
export const minutesOf = (t: string | undefined) => { if (!t) return null; const [h, m] = t.split(':').map(Number); return Number.isFinite(h) && Number.isFinite(m) ? h! * 60 + m! : null; };
